/* eslint-disable no-restricted-globals */
export const targetPath = (target: string, defaultPath: string): string => {
  if (target) {
    const url = new URL(target as string, location.origin)

    return url.pathname
  }

  return defaultPath
}

export const targetQuery = (
  target: string,
  defaultParams: Record<string, any>
): string => {
  if (target) {
    const url = new URL(target as string, location.origin)
    const params = new URLSearchParams(url.search)

    Object.entries(defaultParams).forEach((e) => {
      params.set(e[0], e[1])
    })
    return params.toString()
  }

  return new URLSearchParams(defaultParams).toString()
}

export const targetUrl = (
  target: string,
  defaultPath: string,
  defaultParams: Record<string, any>
): string =>
  `${targetPath(target, defaultPath)}?${targetQuery(target, defaultParams)}`

export const countryFromHeader = (context: any) =>
  context?.req?.headers['CF-IPCountry'] ||
  context?.req?.headers['cf-ipcountry'] ||
  'PL'
